define.alias("ember-cli-string-helpers/helpers/humanize", "settings/helpers/humanize");